<template>
  <div class="video-item">
    <div
      class="video-item-content"
      dt-eid="video_card"
      :dt-params="`video_title=${isCN ? info.title : info.titleEn}`"
      @click="showMask"
    >
      <div class="video-content">
        <!-- <div :class="playerClass"></div> -->
        <!-- <div class="video-mask"></div> -->
        <img
          :src="ImageProcessing(info.poster)"
          class="video-content-item"
          alt=""
        />
        <div class="video-content-icon">
          <img
            src="~@/assets/imgs/video-icon.svg"
            class="video-icon"
            alt=""
          />
        </div>
      </div>
      <div class="video-item-content-title">
        {{ isCN ? info.title : info.titleEn }}
      </div>
      <!-- <div class="video-item-content-tips">
        {{ isCN ? info.media : info.mediaEn }}
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { ImageProcessing } from '@/utils/common';

const props = defineProps({
  info: {
    type: Object,
    default: () => ({
      id: 0,
      title: '',
      titleEn: '',
      vid: '',
      media: '',
      mediaEn: '',
      poster: '',
    }),
  },
});
import { useI18n } from 'vue-i18n';
import { ref, computed, watch } from 'vue';
const { locale } = useI18n();
const langType = ref(localStorage.getItem('lang') || 'zh-CN');
const isCN = computed(() => langType.value === 'zh-CN');

// 监控语言切换，重新赋值语言类型
watch(
  () => locale.value,
  (nv) => {
    // console.log('langType--one', langType.value, isCN.value, nv);
    langType.value = nv;
  },
);

const showMask = () => {
  setTimeout(() => {
    window.open(`/video/detail/${props.info.vid}`);
  }, 0);
};
</script>

<style scoped lang="scss">
.video-item {
  width: 100%;
  height: auto;
  cursor: pointer;
}
.video-item-content {
  width: 100%;
  height: 100%;
  .video-content {
    width: 900px;
    height: 506px;
    margin: 0 auto;
    position: relative;
    .video-content-item {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    .video-content-icon {
      position: absolute;
      bottom: 20px;
      left: 20px;
      width: 100%;
      height: 100%;
      z-index: 99;
      width: 32px;
      height: 32px;
      box-shadow: 0 4px 8px 0 #0000002e;
      .video-icon {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        // box-shadow: 0 4px 8px 0 #0000002e;
      }
    }
  }
}
.video-item-content-title {
  width: 900px;
  margin: 29px auto 0;
  // min-height: 88px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 28px;
  color: #000000;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.video-item-content-tips {
  width: 900px;
  margin: 24px auto 0;
  font-weight: 400;
  font-size: 22px;
  color: #404040;
  line-height: 32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: PingFang SC;
}
.video-item:hover {
  .video-item-content-title {
    color: #367cbe;
  }
  .video-item-content-tips {
    color: #367cbe;
  }
}

@media (max-width: 999.9px) {
  .video-item {
    // padding: 0 16px;
    // box-sizing: border-box;
    width: 100%;
    height: auto;
    .video-item-content {
      width: 100%;
      height: 100%;
      .video-content {
        width: 100%;
        height: 193px;
        margin: 0 auto;
        position: relative;
        .video-content-item {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
        .video-content-icon {
          bottom: 16px;
          left: 16px;
          width: 24px;
          height: 24px;
          box-shadow: 0 3px 6px 0 #0000002e;
        }
      }
      .video-item-content-title {
        width: 100%;
        margin: 8px auto 24px;
        // min-height: 28px;
        font-size: 18px;
        line-height: 28px;
      }
      .video-item-content-tips {
        width: 100%;
        margin: 0 0 24px;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .video-item:hover {
    .video-item-content-title {
      color: #000000;
    }
    .video-item-content-tips {
      color: #404040;
    }
  }
}
</style>
